/*!
* lazyYT (lazy load YouTube videos)
* v1.0.1 - 2014-12-30
* (CC) This work is licensed under a Creative Commons Attribution-ShareAlike 4.0 International License.
* http://creativecommons.org/licenses/by-sa/4.0/
* Contributors: https://github.com/tylerpearson/lazyYT/graphs/contributors || https://github.com/daugilas/lazyYT/graphs/contributors
*
* Usage: <div class="lazyYT" data-youtube-id="laknj093n" data-parameters="rel=0">loading...</div>
*/

;(function ($) {
    'use strict';

    function setUp($el, settings) {
        var width = $el.data('width'),
            height = $el.data('height'),
            ratio = ($el.data('ratio')) ? $el.data('ratio') : settings.default_ratio,
            id = $el.data('youtube-id'),
            padding_bottom,
            innerHtml = [],
            $thumb,
            youtube_parameters = $el.data('parameters') || '';

        ratio = ratio.split(":");

        // width and height might override default_ratio value
        if (typeof width === 'number' && typeof height === 'number') {
          $el.width(width);
          padding_bottom = height + 'px';
        } else if (typeof width === 'number') {
          $el.width(width);
          padding_bottom = (width * ratio[1] / ratio[0]) + 'px';
        } else {
          width = $el.width();

          // no width means that container is fluid and will be the size of its parent
          if (width == 0) {
            width = $el.parent().width();
          }

          padding_bottom = (ratio[1] / ratio[0] * 100) + '%';
        }

        // This HTML will be placed inside 'lazyYT' container

        innerHtml.push('<div class="yt-player__cover">');
        innerHtml.push('<div class="yt-player__icon"></div>');
        innerHtml.push('</div>');

        $el.css({
            'padding-bottom': padding_bottom
        })
        .html(innerHtml.join(''));

        $thumb = $el.find('.yt-player__cover')
          .on('click', function (e) {
            e.preventDefault();
            if (!$el.hasClass('yt-player_loaded')) {
              $el.html('<iframe src="//www.youtube.com/embed/' + id + '?autoplay=1&' + youtube_parameters + '" frameborder="0" allowfullscreen></iframe>')
                .addClass('yt-player_loaded');
            }
          });

    }

    $.fn.lazyYT = function (newSettings) {
      var defaultSettings = {
        default_ratio: '16:9',
        callback: null, // ToDO execute callback if given
        container_class: 'yt-player__container'
      };
      var settings = $.extend(defaultSettings, newSettings);

      return this.each(function () {
          var $el = $(this).addClass(settings.container_class);
          setUp($el, settings);
      });
    };

}(jQuery));

define("modules/lazyYT", function(){});

